import BeeSelect from './select.vue'

BeeSelect.install = (Vue) => {
  Vue.component(BeeSelect.name, BeeSelect)
}

export default BeeSelect



// WEBPACK FOOTER //
// ./src/components/select/index.js